module.exports = __webpack_public_path__ + "img/thumbnail_AfricanElephant_f_albino.6c5818be.png";